import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/modals/reactModalOverlay.css'
// Vite runs Tailwind through the existing PostCSS configuration.
import './styles/tailwind.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import AppProviders from './components/AppProviders'
import * as Sentry from '@sentry/react'
import { i18nReady } from './i18n'
import RouteLoading from './components/common/RouteLoading'
import { env } from './constants/Connections'
import ReactModal from 'react-modal'
import ErrorBoundary from './components/common/ErrorBoundary'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactModal.setAppElement('#root')

Sentry.init({
    dsn: 'https://484cdb10de5b449ab12c5a34c5ea901b@o4504117825896449.ingest.sentry.io/4504117832777729',
    // Stamped by scripts/writeVersion.js; undefined on the dev server.
    release: process.env.REACT_APP_BUILD_ID,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    tracePropagationTargets: ['https://web.upstrivesystem.com'],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    replaysSessionSampleRate: 0.0,
    tracesSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
})

// replace console.* for disable log on production
if (process.env.REACT_APP_ENV === 'prod') {
    // console.log = () => {};
    // console.error = () => {};
    // console.debug = () => {};
}

i18nReady.then(() => {
    createRoot(document.getElementById('root'), { onUncaughtError: Sentry.reactErrorHandler() }).render(
        <React.Suspense fallback={<RouteLoading />}>
            <ErrorBoundary name="root">
                <AppProviders>
                    <App />
                </AppProviders>
            </ErrorBoundary>
        </React.Suspense>
    )
}).catch(error => {
    Sentry.captureException(error)
    const root = document.getElementById('root')
    root.textContent = 'Unable to load the app. Please refresh to try again.'
})

// Shows public/offline.html instead of the browser error page when the app is opened without a network.
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
